import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import { useApolloClient } from '@apollo/client';
import MenuItem from '@material-ui/core/MenuItem';
import SnackbarContext from '../../../containers/CustomSnackbar/SnackbarContext';
import removeUsersFromTeamMutation from '../../../graphql/teams/mutation/removeUsersFromTeam';

const ConfirmDelete = ({
  team, user, closeMenu, refetch,
}) => {
  const [open, setOpen] = React.useState(false);

  function handleClickOpen() {
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
    closeMenu();
  }

  const client = useApolloClient();

  return (
    <div>
      <MenuItem onClick={handleClickOpen}>
        <Typography variant="body1" color="textSecondary">
          Remove user
        </Typography>
      </MenuItem>
      <Dialog
        PaperProps={{ style: { backgroundColor: '#e99698', color: 'black' } }}
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Remove User?</DialogTitle>
        <DialogContent>
          <DialogContentText color="inherit">
            Are you sure you want to remove this user?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="inherit">
            Cancel
          </Button>
          <SnackbarContext.Consumer>
            {(value) => (
              <Button
                onClick={() => {
                  client.mutate({
                    mutation: removeUsersFromTeamMutation,
                    variables: {
                      tid: team._id,
                      uids: [user._id],
                    },
                  })
                    .then(() => {
                      value.openSnackbar('success', 'User removed successfully');
                      console.log('user deleted');
                      handleClose();
                      if (refetch && typeof refetch === 'function') {
                        refetch();
                      } else {
                        console.warn('refetch is not a function');
                      }
                    })
                    .catch((error) => {
                      console.log(error);
                      value.openSnackbar('error', 'Could not remove user');
                      handleClose();
                    });
                }}
                color="inherit"
              >
                Delete
              </Button>
            )}
          </SnackbarContext.Consumer>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ConfirmDelete;
